/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatchPccDemographicsRequest } from './PatchPccDemographicsRequest';
import {
    PatchPccDemographicsRequestFromJSON,
    PatchPccDemographicsRequestFromJSONTyped,
    PatchPccDemographicsRequestToJSON,
} from './PatchPccDemographicsRequest';

/**
 * 
 * @export
 * @interface GetPccDemographicsPrefill200Response
 */
export interface GetPccDemographicsPrefill200Response {
    /**
     * 
     * @type {PatchPccDemographicsRequest}
     * @memberof GetPccDemographicsPrefill200Response
     */
    data?: PatchPccDemographicsRequest;
}

/**
 * Check if a given object implements the GetPccDemographicsPrefill200Response interface.
 */
export function instanceOfGetPccDemographicsPrefill200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPccDemographicsPrefill200ResponseFromJSON(json: any): GetPccDemographicsPrefill200Response {
    return GetPccDemographicsPrefill200ResponseFromJSONTyped(json, false);
}

export function GetPccDemographicsPrefill200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPccDemographicsPrefill200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PatchPccDemographicsRequestFromJSON(json['data']),
    };
}

export function GetPccDemographicsPrefill200ResponseToJSON(value?: GetPccDemographicsPrefill200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PatchPccDemographicsRequestToJSON(value.data),
    };
}

